import GoogleIcon from "./google.svg";
import SaudiFlag from "./saudi-flag.svg";
import TurkishFlag from "./turkish-flag.svg";
import USAFlag from "./usa-flag.svg";
import CampaignsInfoGraphic from "./campaigns/campaigns-infographic.png";
import FormReCaptchaDomainVerificationHighlight from "./form-recaptcha-domain-verification-highlight.webp";
import AtiraSpaceLogoBetaForest from "./logos/atiraspace-beta-forest.png";
import AtiraSpaceLogoBetaMint from "./logos/atiraspace-beta-mint.png";
import AtiraSpaceLogoBetaOcean from "./logos/atiraspace-beta-ocean.png";
import AtiraSpaceLogoBetaPurple from "./logos/atiraspace-beta-purple.png";
import AtiraSpaceLogoBetaScarlet from "./logos/atiraspace-beta-scarlet.png";
import AtiraSpaceLogoBetaSlate from "./logos/atiraspace-beta-slate.png";
import AtiraSpaceLogoBetaSub from "./logos/atiraspace-beta-sub.png";
import AtiraSpaceLogoBetaTerra from "./logos/atiraspace-beta-terra.png";
import AtiraSpaceLogoBetaYellow from "./logos/atiraspace-beta-yellow.png";
import AtiraSpaceLogoIconForest from "./logos/atiraspace-icon-forest.png";
import AtiraSpaceLogoIconMint from "./logos/atiraspace-icon-mint.png";
import AtiraSpaceLogoIconOcean from "./logos/atiraspace-icon-ocean.png";
import AtiraSpaceLogoIconPurple from "./logos/atiraspace-icon-purple.png";
import AtiraSpaceLogoIconScarlet from "./logos/atiraspace-icon-scarlet.png";
import AtiraSpaceLogoIconSlate from "./logos/atiraspace-icon-slate.png";
import AtiraSpaceLogoIconSub from "./logos/atiraspace-icon-sub.png";
import AtiraSpaceLogoIconTerra from "./logos/atiraspace-icon-terra.png";
import AtiraSpaceLogoIconYellow from "./logos/atiraspace-icon-yellow.png";
import AtiraSpaceLogoPurple from "./logos/atiraspace-purple.png";
import AtiraSpaceLogoSub from "./logos/atiraspace-sub.png";
import ChatChattingIconForest from "./chat-widget/chat-chatting-forest.png";
import ChatChattingIconMint from "./chat-widget/chat-chatting-mint.png";
import ChatChattingIconOcean from "./chat-widget/chat-chatting-ocean.png";
import ChatChattingIconPurple from "./chat-widget/chat-chatting-purple.png";
import ChatChattingIconScarlet from "./chat-widget/chat-chatting-scarlet.png";
import ChatChattingIconSlate from "./chat-widget/chat-chatting-slate.png";
import ChatChattingIconTerra from "./chat-widget/chat-chatting-terra.png";
import ChatChattingIconYellow from "./chat-widget/chat-chatting-yellow.png";
import ChatClosedIconForest from "./chat-widget/chat-closed-forest.png";
import ChatClosedIconMint from "./chat-widget/chat-closed-mint.png";
import ChatClosedIconOcean from "./chat-widget/chat-closed-ocean.png";
import ChatClosedIconPurple from "./chat-widget/chat-closed-purple.png";
import ChatClosedIconScarlet from "./chat-widget/chat-closed-scarlet.png";
import ChatClosedIconSlate from "./chat-widget/chat-closed-slate.png";
import ChatClosedIconTerra from "./chat-widget/chat-closed-terra.png";
import ChatClosedIconYellow from "./chat-widget/chat-closed-yellow.png";
import WidgetMessageIcon from "./chat-widget/message.svg";
import WidgetMessageSendIcon from "./chat-widget/message-send.svg";
import WidgetChatIcon from "./chat-widget/chat.svg";
import WidgetCloseIcon from "./chat-widget/close.svg";
import WidgetOtherIcon from "./chat-widget/other.svg";
import AtiraChatLogo from "./chat-widget/atira-chat-logo.png";
import ChatOpenIconForest from "./chat-widget/chat-open-forest.png";
import ChatOpenIconMint from "./chat-widget/chat-open-mint.png";
import ChatOpenIconOcean from "./chat-widget/chat-open-ocean.png";
import ChatOpenIconPurple from "./chat-widget/chat-open-purple.png";
import ChatOpenIconScarlet from "./chat-widget/chat-open-scarlet.png";
import ChatOpenIconSlate from "./chat-widget/chat-open-slate.png";
import ChatOpenIconTerra from "./chat-widget/chat-open-terra.png";
import ChatOpenIconYellow from "./chat-widget/chat-open-yellow.png";
import AIChatbotScript1 from "./chatbot/script-1.png";
import AIChatbotScript2 from "./chatbot/script-2.png";
import AIChatbotHTML1 from "./chatbot/html-1.png";
import AIChatbotHTML2 from "./chatbot/html-2.png";

export const Images = {
  //
  SaudiFlag,
  USAFlag,
  TurkishFlag,
  //
  WidgetChatIcon,
  WidgetMessageSendIcon,
  WidgetMessageIcon,
  WidgetCloseIcon,
  WidgetOtherIcon,

  AtiraChatLogo,
  ChatClosedIconPurple,
  ChatOpenIconPurple,
  ChatChattingIconPurple,

  ChatClosedIconYellow,
  ChatOpenIconYellow,
  ChatChattingIconYellow,

  ChatClosedIconSlate,
  ChatOpenIconSlate,
  ChatChattingIconSlate,

  ChatClosedIconTerra,
  ChatOpenIconTerra,
  ChatChattingIconTerra,

  ChatClosedIconForest,
  ChatOpenIconForest,
  ChatChattingIconForest,

  ChatClosedIconOcean,
  ChatOpenIconOcean,
  ChatChattingIconOcean,

  ChatClosedIconMint,
  ChatOpenIconMint,
  ChatChattingIconMint,

  ChatClosedIconScarlet,
  ChatOpenIconScarlet,
  ChatChattingIconScarlet,
  //
  AtiraSpaceLogoBetaSub,
  AtiraSpaceLogoSub,
  AtiraSpaceLogoIconSub,

  AtiraSpaceLogoBetaPurple,
  AtiraSpaceLogoPurple,
  AtiraSpaceLogoIconPurple,

  AtiraSpaceLogoBetaYellow,
  AtiraSpaceLogoIconYellow,

  AtiraSpaceLogoBetaSlate,
  AtiraSpaceLogoIconSlate,

  AtiraSpaceLogoBetaTerra,
  AtiraSpaceLogoIconTerra,

  AtiraSpaceLogoBetaForest,
  AtiraSpaceLogoIconForest,

  AtiraSpaceLogoBetaScarlet,
  AtiraSpaceLogoIconScarlet,

  AtiraSpaceLogoBetaOcean,
  AtiraSpaceLogoIconOcean,

  AtiraSpaceLogoBetaMint,
  AtiraSpaceLogoIconMint,

  //
  FormReCaptchaDomainVerificationHighlight,
  //
  GoogleIcon,
  //
  CampaignsInfoGraphic,
  //
  AIChatbotScript1,
  AIChatbotScript2,
  AIChatbotHTML1,
  AIChatbotHTML2,
};
